import { ModalContextState, ModalName } from '../../types';

export const modalContextMock: ModalContextState = {
  state: {
    [ModalName.logout]: {
      isOpen: false,
      name: ModalName.logout
    },
    [ModalName.copyTextSuccessToast]: {
      isOpen: false,
      name: ModalName.copyTextSuccessToast
    },
    [ModalName.closeWeekSuccessToast]: {
      isOpen: false,
      name: ModalName.closeWeekSuccessToast
    },
    [ModalName.addReasonSuccessToast]: {
      isOpen: false,
      name: ModalName.addReasonSuccessToast
    },
    [ModalName.closeWeek]: {
      isOpen: false,
      name: ModalName.closeWeek
    },
    [ModalName.deleteShift]: {
      isOpen: false,
      name: ModalName.closeWeek
    },
    [ModalName.deleteShiftErrorAlert]: {
      isOpen: false,
      name: ModalName.closeWeek
    },
    [ModalName.deleteShiftSuccessToast]: {
      isOpen: false,
      name: ModalName.closeWeek
    },
    [ModalName.formUnsavedChanges]: {
      isOpen: false,
      name: ModalName.formUnsavedChanges
    }
  },
  open: () => {},
  close,
  isModalOpen: () => false
};
